// src/context/AppDataContext.js
import React, { createContext, useContext } from "react";
import { baseApi } from "../config";

const DEFAULT_API = baseApi;

const AppDataContext = createContext();

export const AppDataProvider = ({ children }) => {
  const baseApi = DEFAULT_API;

  return (
    <AppDataContext.Provider value={{ baseApi }}>
      {children}
    </AppDataContext.Provider>
  );
};

export const useAppData = () => useContext(AppDataContext);
